module.exports = {"id":"24248","name":"David Pizarro","rating":"73","photo":"./data/images/photos/2/24248.png","club":{"name":"Uni. de Chile","logo":"./data/images/clubs/Uni.deChile.png"},"positions":["MC","MDC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DavidPizarro0.json
// module id = 1001
// module chunks = 0